import encryptDecrypt from '../../cryptography/encryptDecrypt';
import config from '../../../config/config';
import moment from 'moment';
import bulkExpressionParser from '../simpleScript/expressionParser/bulkExpressionParser';

export default async function(
    functionObj={},
    variableObject={},
    parameterObject={},
    functionMap={},
    variableIdMap={}
){
    try{
        const {
            executionObject={}
        } = functionObj;
        const {
            variableName='', 
            variableUnavailable=false, 
        } = executionObject;
        const {
            companyId='', user={}, inhouz_reserved_parameters_xyzh={}
        } = parameterObject;
        const {appEnvironment=''} = inhouz_reserved_parameters_xyzh;

        if(!variableName || variableUnavailable){
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'Variable name is missing.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let parsedParameters = await bulkExpressionParser({
            executionObject,
            variableObject,
            parameterObject,
            functionMap,
            variableIdMap,
            useAllFields : true
        });

        if(parsedParameters.error){
            variableObject[variableName] = {
                error : {
                    message : 'Failed to parse function parameters.'
                }
            }
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'Failed to resolve function parameters.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let variableCopy = parsedParameters['variableObject'];
        let resolvedParams = parsedParameters['accumulator'];

        let payload = {
            companyId,
            environment : appEnvironment,
            documentName : resolvedParams['documentName'] || '',
            fileKey : resolvedParams['fileKey'] || '',
            templateId : resolvedParams['templateId'] || '',
            pageCaptureDelayMS : resolvedParams['pageCaptureDelayMS'] || 0,
            fileStorageServiceId : resolvedParams['fileStorageServiceId'] || '',
            sendViaEmail : resolvedParams['sendViaEmail'] || false,
            emailSenderName : resolvedParams['emailSenderName'] || '',
            recipientEmail : resolvedParams['recipientEmail'] || '',
            emailSubject : resolvedParams['emailSubject'] || '',
            emailMessage : resolvedParams['emailMessage'] || '',
            queryKey : `${Math.random()}${Math.random()}${Math.random()}${Math.random()}`
        }

        if(
            !payload['templateId'] ||
            typeof payload['templateId'] !== 'string'
        ){
            variableObject[variableName] = {
                error : {
                    message : 'PDF generator template ID is required.'
                }
            }
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'PDF generator template ID is required.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        if(
            typeof resolvedParams['data'] !== 'object' ||
            Array.isArray(resolvedParams['data'])
        ){
            variableObject[variableName] = {
                error : {
                    message : 'Data must be a valid JSON object.'
                }
            }
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'Data must be a valid JSON object.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let encryptedPayload = encryptDecrypt(
            JSON.stringify({
                payload,
                expirationTimestamp : moment().add(1000, 'seconds').unix() * 1000
            }),
            true
        );

        let response = await fetch(
            `${config.devServerProxy}/api/pdfgenerator/document/startdocumentgeneration`,
            {
                method : 'POST',
                headers : {
                    'Accept':"application/json",
                    'Content-Type':"application/json",
                    'Cache': 'no-cache'
                },
                credentials : 'omit',
                body : JSON.stringify({
                    encryptedPayload,
                    data : resolvedParams['data'] || {},
                    user
                })
            }
        )
        .then(resp => resp.json())
        .catch((error) => {
            return {
                error : {
                    message : error.message
                }
            }
        });

        variableCopy[variableName] = response;
        return {
            hasError : false,
            errorPayload : undefined,
            hasReturnStatement : false,
            returnStatement : undefined,
            updatedVariableObject : variableCopy
        }
    }catch(e){
        console.log('/utils/functionParser/general/functionTypeParser/generateServerPdfParser catch block error', e);
        return {
            updatedVariableObject : variableObject,
            hasError : true,
            errorPayload : e.stack,
            hasReturnStatement : false,
            returnStatement : undefined
        } 
    }
}